import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/admin/Sidebar';
import TopNavbar from '../components/admin/TopNavbar';
import StatsCards from '../components/admin/StatsCards';
import RecentOrders from '../components/admin/RecentOrders';
import DashboardCharts from '../components/admin/DashboardCharts';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [adminSession, setAdminSession] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    // Check for admin session
    const session = localStorage.getItem('adminSession') || sessionStorage.getItem('adminSession');
    if (!session) {
      navigate('/admin');
      return;
    }
    setAdminSession(JSON.parse(session));
  }, [navigate]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  if (!adminSession) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      <div className="dashboard-main">
        <TopNavbar 
          onMenuClick={toggleSidebar}
          adminName={adminSession.username || adminSession.email}
        />
        
        <main className="dashboard-content">
          <div className="page-header">
            <h1 className="page-title">Dashboard</h1>
            <p className="page-subtitle">Welcome back! Here's what's happening today</p>
          </div>

          <StatsCards />
          <RecentOrders />
          <DashboardCharts />
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
